$(document).ready(function () {
  $(".tab-link").eq(0).addClass("active");
  $(".tab-content").eq(0).show();

  $(".tab-link").on("click", function (event) {
    $(".font_family input:radio:first").prop("checked", true).trigger("click");
    var clickedIndex = $(this).index(".tab-link");
    var tab_id = $(this).attr("data_tab");
    $(".tab-content").removeClass("active");
    $(".tab-link").removeClass("active");
    $(this).addClass("active");

    $(".tab-content").hide();
    $("#tab-" + tab_id)
      .addClass("active")
      .show();

    $(".tab-content").each(function () {
      if ($(this).hasClass("active")) {
        $(this).find("input").removeAttr("disabled");
      } else {
        $(this).find("input").val("");
        $(this).find("input").attr("disabled", "disabled");
      }
    });
  });

  // Set icons -------------------

  $(".key_layout span").each(function () {
    var rrr = $(this).attr("data-value");
    $(this).click(function () {
      var input = $(this).parent().siblings("input");
      var currentValue = input.val();
      if (currentValue.length < 22) {
        input.val(currentValue + rrr);
        var currentLength = input.val().length;
        var remaining = 22 - currentLength;
        input
          .siblings()
          .find(".the-count")
          .text(remaining + " characters remaining");
        if (remaining == 0) {
          input.siblings().find(".the-count").css("color", "#f2a008");
        } else {
          input.siblings().find(".the-count").css("color", "#000");
        }
      }
    });
  });

  // counters--------------------

  $(".text--input--field").on("input", function () {
    var count_input = $(this).siblings();
    var inner__value = $(count_input).find(".the-count");
    var maxLength = 22;
    var currentLength = $(this).val().length;
    var remaining = maxLength - currentLength;

    $(inner__value).text(remaining + " characters remaining");

    if (currentLength >= maxLength) {
      $(this).val($(this).val().substr(0, maxLength));
      $(inner__value).css("color", "#f2a008");
    } else {
      $(inner__value).css("color", "#000");
    }
  });

  // Morse code -------------------

  var morseCode = {
    init() {
      $("[id=morse]").on("keyup", function () {
        let container = $(this).closest("form");
        container.length == 0 && (container = $("body"));
        var value = $(this).val(),
          output = "";
        value === "" && container.find("#text").text("");
        for (var i = 0; i < value.length; i++)
          output += morseCode.converter[value.charAt(i).toLowerCase()];
        container.find("#morse-text").text(output),
          container.find("#morse-code").val(output);
      });
    },
    converter: {
      a: ".- ",
      b: "-... ",
      c: "-.-. ",
      d: "-.. ",
      e: ". ",
      f: "..-. ",
      g: "--. ",
      h: ".... ",
      i: ".. ",
      j: ".--- ",
      k: "-.- ",
      l: ".-.. ",
      m: "-- ",
      n: "-. ",
      o: "--- ",
      p: ".--. ",
      q: "--.- ",
      r: ".-. ",
      s: "... ",
      t: "- ",
      u: "..- ",
      v: "...- ",
      w: ".-- ",
      x: "-..- ",
      y: "-.-- ",
      z: "--.. ",
      1: ".---- ",
      2: "..--- ",
      3: "...-- ",
      4: "....- ",
      5: "..... ",
      6: "-.... ",
      7: "--... ",
      8: "---.. ",
      9: "----. ",
      0: "----- ",
      ".": ".-.-.- ",
      ",": "--..-- ",
      "?": "..--.. ",
      "'": ".----. ",
      "!": "-.-.-- ",
      "/": "-..-. ",
      "(": "-.--. ",
      ")": "-.--.- ",
      "&": ".-... ",
      ":": "---... ",
      ";": "-.-.-. ",
      "=": "-...- ",
      "+": ".-.-. ",
      "-": "-....- ",
      _: "..--.- ",
      '"': ".-..-. ",
      $: "...-..- ",
      "@": ".--.-. ",
      " ": "/",
    },
  };
  $(document).ready(function () {
    morseCode.init();
  });

  // mapbox---find--search---click --------------------
});


$(document).ready(function () {
  $(".font_family").click(function () {
    var font_css = $(this).css("font-family");
    console.log(font_css);
    $(".text--input--field").css("font-family", font_css);
    $(".mapboxgl-ctrl-geocoder--input").css("font-family", font_css);
  });
});






// BirthStone js


window.getImageUrl = function(key, callback) {

    let selectedMetal = $('.swatch-custom-image.swatch-selected').data('value');
    if (selectedMetal && selectedMetal.toLowerCase() === 'silver') {
        key += '_silver';
    }

    let extensions = ["webp", "png", "jpg", "jpeg"];
    let found = false;
    

    extensions.forEach((ext) => {
        if (found) return;
        let url = `/cdn/shop/files/${key}.${ext}`;
        let img = new Image();
        img.onload = function () {
            if (!found) {
                found = true;
                callback(url);
            }
        };
        img.onerror = function() {};
        img.src = url;
    });
};


function silverImage() {

    let selectedMetal = $('.swatch-custom-image.swatch-selected').data('value');

     $(".custom-option-image").hide();
     $(".load_image").show();

    let img = $(".load_image");

    if (selectedMetal && selectedMetal.toLowerCase() === 'silver') {
        img.attr("src", img.data("silver"));
        img.attr("srcset", img.data("silver"));
    } else {
        img.attr("src", img.data("default"));
        img.attr("srcset", img.data("default"));
    }
}


silverImage();


$(document).on('click', '.product-customisation__item', function () {
    $(".custom-option-image").attr("src", "").hide();
    $(".load_image").show(); 

    silverImage();

    $('.custom-drawer').addClass('is-open');
    $('.custom-drawer-overlay').addClass('is-open');
    $('body').css('overflow', 'hidden');

});


let state = {};
let totalAllowed = 0;


function resetCustomization() {

    $(".bold_option input[type='checkbox']").prop("checked", false);
    $(".bold_option input[type='hidden']").val('');
    $(".bold_option_value").removeClass("active_custom_bold");

    state = {};

    $(".custom-option-image").attr("src", "").hide();
    $(".load_image").show();

    window.currentBirthstoneKey = '';
    window.currentBirthstoneUrl = '';

    silverImage();

    $("[data-customisation-count]").text("0/" + totalAllowed);

    $('.birthstone-select-btn').show();
    $('.birthstone-cart-btn').hide();

    $('.custom-drawer__close svg path').attr(
     'd',
     'M14.0205 0.707031L8.7168 6.00977L14.0205 11.3135L13.3135 12.0205L8.00977 6.7168L2.70703 12.0205L2 11.3135L7.30273 6.00977L2 0.707031L2.70703 0L8.00977 5.30273L13.3135 0L14.0205 0.707031Z'
    );

}


$(document).ready(function () {
    // var state = {};
    totalAllowed = $(".bold_option").length;
    let productHandle = $("[data-product-handle]").attr("data-product-handle");

    function updateCounter() {
        let count = Object.keys(state).length;
        $("[data-customisation-count]").text(count + "/" + totalAllowed);

        if (count === totalAllowed) {
            $('.birthstone-select-btn').hide();
            $('.birthstone-cart-btn').show();
            $('.custom-drawer__close svg path').attr(
                'd',
                'M6.2 11.2L1.8 6.8L0.4 8.2L6.2 14L16 4.2L14.6 2.8L6.2 11.2Z'
            );

        } else {
            $('.birthstone-select-btn').show();
            $('.birthstone-cart-btn').hide();
            $('.custom-drawer__close svg path').attr(
                'd',
                'M14.0205 0.707031L8.7168 6.00977L14.0205 11.3135L13.3135 12.0205L8.00977 6.7168L2.70703 12.0205L2 11.3135L7.30273 6.00977L2 0.707031L2.70703 0L8.00977 5.30273L13.3135 0L14.0205 0.707031Z'
            );
        }
    }

    // ✅ DYNAMIC: Build key from any number of birthstones
    function buildImageKey() {
        let parts = [];

        $(".bold_option").each(function (index) {
            let val = state[index + 1];
            parts.push(val ? val.toLowerCase() : "april");
        });

        return productHandle + "_" + parts.join("_");
    }

    function updateImage() {
        if (Object.keys(state).length === 0) {

            $(".custom-option-image").attr("src", "").hide();
            $(".load_image").show();
            return;
        }

        let key = buildImageKey();
        $(".load_image").hide();

        // ✅ Use global getImageUrl
        window.getImageUrl(key, function (url) {
            $(".custom-option-image").attr("src", url).show();
            window.currentBirthstoneKey = key;
            window.currentBirthstoneUrl = url;
        });
    }

    $(document).on("change", ".bold_option input[type='checkbox']", function () {
        let $wrap = $(this).closest(".bold_option");

        if ($(this).is(":checked")) {
            $wrap.find("input[type='checkbox']").not(this).prop("checked", false);
        }

        let optionIndex = $(".bold_option").index($wrap) + 1;
        let value = $(this).val();

        if ($(this).is(":checked")) {
            state[optionIndex] = value;
        } else {
            delete state[optionIndex];
        }

        $wrap.find("input[type='hidden']").val($(this).is(":checked") ? value : "");

        $wrap.find(".bold_option_value").removeClass("active_custom_bold");

        if (state[optionIndex]) {
            $(this).closest(".bold_option_value").addClass("active_custom_bold");
        }

        updateImage();
        updateCounter();
    });

});


$(document).on('click', '.custom-drawer__close, .custom-drawer-overlay, .customisation-drawer__confirm', function () {

    $('.custom-drawer').removeClass('is-open');
    $('.custom-drawer-overlay').removeClass('is-open');
    $('body').css('overflow', 'auto');

    let url = window.currentBirthstoneUrl;
    if (!url) {
        console.warn("❌ No image URL");
        return;
    }

    let productSection = null;
    window.theme.sections.instances.forEach(instance => {
        if (instance.type === 'product-template' || instance.type === 'product') {
            productSection = instance;
        }
    });

    if (!productSection || !productSection.flickity) {
        console.warn("❌ Flickity not found");
        return;
    }

    let themeSlideshow = productSection.flickity;
    let flickity = themeSlideshow.slideshow;

    let $mainSlider = $('[data-product-photos]');
    let $thumbSlider = $('[data-product-thumbs]');
    let $thumbScroller = $('[data-product-thumbs-scroller]');

    let oldSlide = $mainSlider.find('.ab-birthstone-slide')[0];
    if (oldSlide) flickity.remove(oldSlide);
    $thumbSlider.find('.ab-birthstone-thumb').remove();

    let existingImg = $mainSlider.find('.product-main-slide img').first();
    let aspectRatio = existingImg.attr('data-aspectratio') || '1';
    let paddingBottom = (1 / parseFloat(aspectRatio) * 100).toFixed(2);
    let newIndex = flickity.slides.length;

    let newSlideEl = $(`
        <div class="product-main-slide secondary-slide ab-birthstone-slide"
             data-product-photo
             data-index="${newIndex}"
             data-id="birthstone-custom">
            <div class="product-image-main">
                <div class="image-wrap" style="height:0; padding-bottom:${paddingBottom}%;">
                    <img class="lcp"
                         src="${url}"
                         data-src="${url}"
                         data-aspectratio="${aspectRatio}"
                         data-sizes="auto"
                         alt="Birthstone combination">
                </div>
            </div>
        </div>
    `)[0];

    let $newThumbLink = $(`
        <a href="#"
           class="image-wrap product__thumb"
           data-id="birthstone-custom"
           data-index="${newIndex}"
           data-product-thumb
           style="height:0; padding-bottom:${paddingBottom}%;">
            <img class="lcp" src="${url}" alt="Birthstone combination">
        </a>
    `);

    let $newThumb = $(`
        <div class="product__thumb-item ab-birthstone-thumb"
             data-product-thumb-item
             data-index="${newIndex}"
             data-group>
        </div>
    `);
    $newThumb.append($newThumbLink);

    if ($thumbScroller.length) {
        $thumbScroller.append($newThumb);
    } else {
        $thumbSlider.append($newThumb);
    }

    flickity.append(newSlideEl);

    setTimeout(() => {
        let targetIndex = flickity.slides.length - 1;

        let allThumbLinks = Array.from(
            $thumbSlider[0].querySelectorAll('.product__thumb-item:not(.hide) a[data-product-thumb]')
        );
        themeSlideshow.childNavLinks = allThumbLinks;
        themeSlideshow.childNavEls = Array.from(
            $thumbSlider[0].querySelectorAll('.product__thumb-item:not(.hide)')
        );

        allThumbLinks.forEach((link, i) => {
            if (i === targetIndex) {
                let newLink = link.cloneNode(true);
                link.parentNode.replaceChild(newLink, link);
                allThumbLinks[i] = newLink;
                themeSlideshow.childNavLinks = allThumbLinks;

                newLink.addEventListener('click', function(e) {
                    e.preventDefault();
                    flickity.select(targetIndex);
                });
                newLink.addEventListener('focus', function(e) {
                    flickity.select(targetIndex);
                });
            }
        });

        flickity.select(targetIndex);
        flickity.resize();

        allThumbLinks.forEach(link => link.classList.remove('is-active'));
        allThumbLinks[targetIndex] && allThumbLinks[targetIndex].classList.add('is-active');
        
        flickity.off('select.birthstone');
        flickity.on('select', function() {
            let currentIndex = flickity.selectedIndex;
            let links = $thumbSlider[0].querySelectorAll('.product__thumb-item:not(.hide) a[data-product-thumb]');
            links.forEach((l, i) => {
                l.classList.toggle('is-active', i === currentIndex);
            });
        });

        // console.log(`✅ Done - index: ${targetIndex}, total: ${flickity.slides.length}`);
    }, 150);
});


$(document).on('click', '.swatch-custom-image.swatch-selector', function () {
 resetCustomization();
});


